import kountSDK from '@kount/kount-web-client-sdk';

export default function getKountSDK() {
  return kountSDK;
}
